import CallToAction from '../components/CallToAction'

export default function Hero() {
  return (
    <section id="hero" style={{
      minHeight: '100vh',
      display: 'flex',
      alignItems: 'center',
      background: 'linear-gradient(350deg, var(--bg-primary) 0%, var(--bg-secondary) 80%)',
      paddingTop: '100px'
    }}>
      <div className="container">
        <div className="grid grid-1" style={{ alignItems: 'justify', gap: 'var(--spacing-2xl)' }}>
          {/* Content */}
          <div>
            <h1 style={{
              marginBottom: 'var(--spacing-lg)',
              background: 'linear-gradient(135deg, var(--text-primary) 0%, var(--accent) 100%)',
              WebkitBackgroundClip: 'text',
              WebkitTextFillColor: 'transparent',
              backgroundClip: 'text'
            }}>
              Descubre el poder de la innovación con Vortex Software.
            </h1>
            <p style={{
              fontSize: '1.25rem',
              marginBottom: 'var(--spacing-xl)',
              color: 'var(--text-secondary)',
              lineHeight: '1.8'

            }}>
              Especialistas en aplicaciones móviles innovadoras que transforman la educación, el aprendizaje y la gestión scout. Nuestras apps combinan tecnología de vanguardia con interfaces intuitivas para ofrecer experiencias excepcionales.               </p>
            <CallToAction />
          </div>

          {/* Mockup */}
          <div style={{ textAlign: 'center' }}>
            <div style={{
              position: 'relative',
              display: 'inline-block'
            }}>
              <img
                src="/icons/logo.png"
                alt="AscensosApp Vortex"
                style={{
                  maxWidth: '65%',
                  height: 'auto',
                  borderRadius: 'var(--radius-lg)',
                  boxShadow: 'var(--shadow-lg)',
                  border: '1px solid var(--border)'
                }}
              />
              {/* Floating elements for visual appeal */}
              <div style={{
                position: 'absolute',
                top: '-20px',
                right: '-20px',
                width: '60px',
                height: '60px',
                background: 'var(--accent)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1.5rem',
                animation: 'float 3s ease-in-out infinite'
              }}>
                <img src="/icons/helm.gif" style={{ width: '100px' }} />
              </div>
              <div style={{
                position: 'absolute',
                bottom: '-20px',
                left: '-20px',
                width: '40px',
                height: '40px',
                background: 'var(--accent)',
                borderRadius: '50%',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                fontSize: '1rem',
                animation: 'float 3s ease-in-out infinite 1.5s'
              }}>
                <img src="/icons/compass.gif" style={{ width: '100px' }} />
              </div>
            </div>
          </div>
        </div>
      </div>

      <style jsx>{`
        @keyframes float {
          0%, 100% { transform: translateY(0px); }
          50% { transform: translateY(-10px); }
        }
      `}</style>
    </section>
  )
} 